function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingClockOrangeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 42.964 18.894 v 26.115 L 32.013 59.105 c -1.015 1.306 -0.778 3.188 0.528 4.203 c 0.546 0.424 1.193 0.63 1.835 0.63 c 0.893 0 1.777 -0.398 2.367 -1.157 l 11.582 -14.908 c 0.408 -0.525 0.63 -1.172 0.63 -1.838 V 18.894 c 0 -1.654 -1.341 -2.995 -2.995 -2.995 C 44.305 15.899 42.964 17.24 42.964 18.894 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,127,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.793 11.005 l -7.31 5.298 C 70.988 6.101 58.251 0.076 44.924 0.076 C 20.153 0.076 0 20.229 0 45 c 0 24.772 20.153 44.924 44.924 44.924 c 4.306 0 8.565 -0.608 12.658 -1.808 c 1.587 -0.465 2.497 -2.129 2.032 -3.716 c -0.466 -1.588 -2.133 -2.495 -3.716 -2.032 c -3.546 1.039 -7.238 1.567 -10.973 1.567 C 23.456 83.934 5.99 66.469 5.99 45 S 23.456 6.066 44.924 6.066 c 11.597 0 22.282 4.986 29.698 13.76 l -7.645 5.541 c -1.457 1.056 -0.91 3.347 0.867 3.63 l 14.808 2.363 c 2.361 0.377 4.581 -1.232 4.958 -3.593 l 2.363 -14.808 C 90.257 11.181 88.25 9.948 86.793 11.005 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,127,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.821 66.883 c -1.345 -0.961 -3.216 -0.646 -4.177 0.7 c -2.157 3.023 -4.731 5.723 -7.653 8.024 c -1.3 1.024 -1.524 2.906 -0.501 4.206 c 0.591 0.751 1.469 1.143 2.355 1.143 c 0.648 0 1.302 -0.21 1.85 -0.641 c 3.37 -2.653 6.339 -5.767 8.825 -9.254 C 82.482 69.713 82.169 67.843 80.821 66.883 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,127,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.853 42.005 c -1.654 0 -2.995 1.341 -2.995 2.995 c 0 3.106 -0.366 6.196 -1.088 9.183 c -0.389 1.608 0.6 3.226 2.207 3.615 c 0.237 0.058 0.473 0.085 0.706 0.085 c 1.351 0 2.578 -0.921 2.909 -2.292 c 0.834 -3.447 1.256 -7.011 1.256 -10.591 C 89.848 43.346 88.508 42.005 86.853 42.005 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,127,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingClockOrangeOutline);
export default __webpack_public_path__ + "static/media/pending-clock-orange-outline.55ea3ad12e74bdb33903e69261db00d3.svg";
export { ForwardRef as ReactComponent };